import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number | null, currency = 'USD') {
  if (value === null || typeof value === 'undefined' || Number.isNaN(value)) {
    return 'N/A';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number | null) {
  if (value === null || typeof value === 'undefined' || Number.isNaN(value)) {
    return 'N/A';
  }
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercentage(value: number | null) {
  if (value === null || typeof value === 'undefined' || Number.isNaN(value)) {
    return 'N/A';
  }
  return `${formatNumber(value)}%`;
}

export function formatMonths(value: number | null) {
  if (value === null || value === Infinity || Number.isNaN(value)) {
    return 'Over 100 years';
  }
  if (value === 0) return 'Instantly';
  const years = Math.floor(value / 12);
  const months = Math.round(value % 12);
  let result = '';
  if (years > 0) result += `${years} year${years > 1 ? 's' : ''} `;
  if (months > 0) result += `${months} month${months > 1 ? 's' : ''}`;
  if(result === '') return 'Instantly';
  return result.trim();
}

export function formatYears(value: number | null) {
  if (value === null || value === Infinity || Number.isNaN(value)) {
    return 'N/A';
  }
   if (value === 0) return '';
  return `(${formatNumber(value)} years)`;
}
